import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function IdentitySection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);
  return <section ref={ref} id="historia" className="py-24 md:py-32 relative overflow-hidden" data-id="element-155">
      <div className="absolute inset-0 z-0" data-id="element-156">
        <motion.img style={{
        y,
        scale: 1.1
      }} src="https://cdn.magicpatterns.com/uploads/d5nSz1L82oA5h3uMfAYubz/imagen_2.jpg" alt="Luxury Barbershop Interior" className="w-full h-full object-cover opacity-30" data-id="element-157" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121212] via-[#121212]/80 to-transparent" data-id="element-158"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-159">
        <motion.div className="max-w-3xl" initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-160">
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl mb-10 leading-tight" data-id="element-161">
            Identidad <br data-id="element-162" />
            <span className="text-gold italic" data-id="element-163">Onyx & Steel</span>
          </h2>
          <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed mb-8" data-id="element-164">
            Onyx representa sofisticación. Steel representa fuerza. Juntos,
            definen una experiencia de cuidado personal que se niega a
            comprometerse.
          </p>
          <p className="text-lg text-white/60 font-light leading-relaxed" data-id="element-165">
            No hacemos lo promedio. No hacemos las cosas con prisa. Creamos
            confianza, un corte a la vez.
          </p>
        </motion.div>
      </div>
    </section>;
}